//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ShippingMenu',
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      imageUrl: "",
      menuTitle: "",
      menuItems: [],
      activeMenuItem: "",
    }
  },
  methods:{
      isActive (menuItemLink)
      {
        return this.activeMenuItem === menuItemLink;
      },
      fillData (content)
      {
        const details = {}
        Object.assign(details, content);
        this.imageUrl = details.image.fieldValue.fullFileUrl;
        this.menuTitle = details.menu_title.fieldValue.value;
        this.menuItems = details.menu_items;
        this.activeMenuItem = this.$route.path.split('/').pop();
      },
      async getUniqueMenuData(pageName){
        const data = (await this.$axios.get(`/contents` + pageName)).data
        let menuData;
        if(data)
        {
          const details = data.details
          if(details && details.sections && details.sections.length > 1){
            menuData = details.sections[1]
          }
        }
        return menuData
      },
      async getData() {
        switch(this.$route.path)
        {
          case '/return-policy':
          case '/shipping':
          case '/birthstone-guide':
            return (await this.$axios.get(`/contents/shipping-menu`)).data.details
          case '/ring-size-guide':
          case '/our-story':
          case '/contact-us':
          case '/faqs':
            return await this.getUniqueMenuData(this.$route.path)
          default: 
            return
        }
      },
  },
  async mounted ()
  {
    let details = await this.getData()
    if(details) {
      this.fillData (details);
    }
  }
}
